import React from 'react'
import { View, ViewStyle } from 'react-native'
import { upperCase } from 'lodash'
import { StyleService, useStyleSheet } from '@style/service.ts'
import { Text } from '@components/base'
import { Slider, SliderProps } from '@components'

interface DescriptiveSliderProps extends SliderProps {
  descriptionsLookup: { [key: number]: string }
  value: number
  min?: number
  max?: number
  onValueChanged: (value: number) => void
  style?: ViewStyle
}

export const DescriptiveSlider = (props: DescriptiveSliderProps) => {
  const styles = useStyleSheet(themedStyle)
  const {
    descriptionsLookup,
    value,
    min = 1,
    max = 10,
    onValueChanged,
    style,
    ...sliderProps
  } = props

  const onValuesChange = (values: number[]) => {
    onValueChanged(values[0])
  }

  return (
    <View style={style}>
      <View style={styles.header}>
        <Text type="tiny" bold>
          {upperCase(descriptionsLookup[value])}
        </Text>
      </View>
      <Slider
        min={min}
        max={max}
        step={1}
        values={[value]}
        onValuesChange={onValuesChange}
        {...sliderProps}
      />
    </View>
  )
}

const themedStyle = StyleService.create({
  header: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: 16,
  },
})
